import { wsService } from "./wsService";

const section = "contabilidad";

function estado(param = {}) {
  return wsService.make_post_request(section + "/estado", param);
}

function mapeo(param = {}) {
  return wsService.make_post_request(section + "/mapeo", param);
}

function mapear(param = {}) {
  return wsService.make_post_request(section + "/mapear", param);
}

function sugerirMapeo(param = {}) {
  return wsService.make_post_request(section + "/sugerir_mapeo", param);
}

// Saldos iniciales sugeridos + pre-vuelo del backfill para una fecha de corte (B.5)
function puestaEnMarcha(param = {}) {
  return wsService.make_post_request(section + "/puesta_en_marcha", param);
}

function habilitar(param = {}) {
  return wsService.make_post_request(section + "/habilitar", param);
}

function deshabilitar(param = {}) {
  return wsService.make_post_request(section + "/deshabilitar", param);
}

export const contabilidadService = {
  estado,
  mapeo,
  mapear,
  sugerirMapeo,
  puestaEnMarcha,
  habilitar,
  deshabilitar,
};
